import { createContext, useContext } from "react";
export type LoadContent = {
  loading: boolean;
  setLoader: (c: boolean) => void;
};
export const LoadContext = createContext<LoadContent>({
  loading: false, // set a default value
  setLoader: () => {},
});
export const useLoadContext = () => useContext(LoadContext);
